import { Capacitor } from '@capacitor/core'
import { SafeArea } from 'capacitor-plugin-safe-area'
import { StatusBar, Style } from '@capacitor/status-bar'
import { TextZoom } from '@capacitor/text-zoom'
import { NavigationBar } from '@capgo/capacitor-navigation-bar'
import { Device } from '@capacitor/device'

const disableNav = ref(false)

export const insets = reactive({ top: 0, bottom: 0 })
export const layoutSize = reactive({ header: 0, bar: 0 })

export const initLayout = async () => {
  if (Capacitor.isNativePlatform()) {
    StatusBar.setOverlaysWebView({ overlay: true })
    StatusBar.setStyle({ style: Style.Light })
    // SafeArea.setImmersiveNavigationBar()
    
    const info = await Device.getInfo()

    if (info.androidSDKVersion && info.androidSDKVersion <= 29) {
      disableNav.value = true
    } else {
      NavigationBar.setNavigationBarColor({ color: 'transparent' })
    }

    TextZoom.set({ value: 1 })
  }
  
  const { top, bottom } = await getInsets()
  setInsets(top, disableNav.value ? 0 : bottom)

  SafeArea.addListener('safeAreaChanged', ({ insets: { top, bottom } }) => {
    setInsets(top, disableNav.value ? 0 : bottom)
  })
}

export const setInsets = (top: number, bottom: number) => {
  const root = document.body

  insets.top = top
  insets.bottom = bottom

  root.style.setProperty('--inset-top', top + 'px')
  root.style.setProperty('--inset-bottom', bottom + 'px')
}

export const setLayout = (values: {
  header?: number,
  bar?: number
}) => {
  if (values.header) layoutSize.header = Math.round(values.header)
  if (values.bar) layoutSize.bar = Math.round(values.bar)

  return layoutSize
}

export const getInsets = async () => {
  const { insets } = await SafeArea.getSafeAreaInsets()
    
  return {
    top: insets.top,
    bottom: insets.bottom
  }
}

export const setStatusBarColor = (color: 'light' | 'dark') => {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('StatusBar')) {
    window.dispatchEvent(new CustomEvent('color', { detail: color }))
    return
  }

  StatusBar.setStyle({ style: color === 'light' ? Style.Light : Style.Dark })
}